import styled from 'styled-components'

export const Wrapper = styled('div')`
    margin-top: 50px;
`